<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                <strong v-if="status_form==0">{{ $t('deliveryOperation') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">

                <CButton @click="open_refer_modal()" type="submit" class="mr-1" size="sm" color="secondary">
                  {{ $t('changeStatus') }}
                </CButton>
                <!--                <CButton type="submit" @click="print()" size="sm" class="mr-1" color="secondary">-->
                <!--                  {{ $t('buttons.print') }}-->
                <!--                </CButton>-->
                <!--                <CButton  type="submit" size="sm" class="mr-1" color="secondary">-->
                <!--                  {{$t('printPlatform')}}-->
                <!--                </CButton>-->

              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow class="m-1">
              <CCol col="3">
                <date-picker
                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>


              <!--              <CCol col="2">-->
              <!--                <CInput-->
              <!--                    placeholder="شماره فاکتور"-->
              <!--                />-->
              <!--              </CCol>-->

              <CCol col="2">
                <CButton size="sm" color="secondary" @click="get_lists">
                  {{ $t('search') }}
                </CButton>
              </CCol>
            </CRow>

            <div id="print_delivery_operation">
              <CDataTableFixed
                  :items="exit_product_inventory_items"
                  :fields="exit_product_inventory_fields"
                  striped
                  :checkbox="true"
                  checkbox_key="factorId"
                  :checkbox_ids.sync="id_checkbox_items"
                  border
                  sorter
                  :column-filter="true"
                  :items-per-page="200"

                  hover
                  @row-clicked="table_row_clicked"

                  pagination
              >
                <template #row="{item,index}">

                  <td style="text-align: center">
                    <p>{{ index + 1 }}</p>
                  </td>
                </template>

                <template #address="{item}">

                  <td>
                    <p v-if="item.addresses.length>0">
                      {{ item.addresses[0].cityName + " - " + item.addresses[0].addressText }}</p>
                  </td>
                </template>
                <template #factorCode="{item}">
                  <td>
                    <p class="text-center">{{ item.factorCode }}</p>
                  </td>
                </template>


                <template #carTitle="{item}">
                  <td>
                    <p class="text-center" v-if="item.carTitle!=null">{{ item.carTitle }}</p>
                  </td>
                </template>
                <template #routeName="{item}">
                  <td>
                    <p class="text-center" v-if="item.routeName!=null">{{ item.routeName }}</p>
                  </td>
                </template>
                <template #toziKonande="{item}">
                  <td>
                    <p class="text-center" v-if="item.toziKonande!=null">{{ item.toziKonande }}</p>
                  </td>
                </template>

                <template #driver-filter="{item}">
                  <CSelect
                      :options="['undefined','any']"
                      @change="setDateFilter"
                      class="mr-2"
                  />
                </template>


              </CDataTableFixed>

            </div>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="change_refer_modal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        size="sm"
        :title="$t('components.changeStatus')"
    >

      <CRow>
        <CCol col="12">

          <CRow v-if="choose_driver" form class="form-group">
            <CCol tag="label" sm="3" class="col-form-label">
              {{ $t('components.driver') }}
            </CCol>
            <CCol sm="9">
              {{ refer_person }}
              <treeselect
                  v-model="refer_person"
                  :async="async_person_search"
                  :options="refer_person_options"
                  :load-options="load_persons"
                  :placeholder="$t('driver')"
                  :normalizer="normalizer_persons"
              />

            </CCol>
          </CRow>

          <!--          <CInput-->
          <!--              :label="$t('components.summary')"-->
          <!--              horizontal-->
          <!--              v-model="change_status_summary"-->
          <!--          />-->


        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="change_status_data(0)"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="change_refer_modal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>
    <div v-show="false">
      <div id="print_delivery_operation_header" class="border-dark">
        <CCardHeader>
          <CRow style="border: 1px solid #000">

            <CCol sm="4" md="4" style="text-align: right">
              <h2>{{ get_date(new Date()) }}</h2>
            </CCol>
            <CCol sm="4" md="4" style="text-align: center">
              <h2>Delivery Invoices</h2>

            </CCol>
            <CCol sm="4" md="4" style="text-align: left">
              <CImg :src="get_logo()" width="100px" height="50px"/>

            </CCol>
          </CRow>

        </CCardHeader>

      </div>

      <div id="print_report_footer" class="border-dark">
        <CCardHeader>
          <CRow style="border: 1px solid #000">
            <CCol sm="4" md="4" style="text-align: start">
              <h2>{{ $t('docCreator') }} : {{ get_user_name() }}</h2>
            </CCol>
            <CCol sm="4" md="4" style="text-align: center">
              <h2 id="pageFooter" class="pageFooter"></h2>
            </CCol>
            <CCol sm="4" md="4" style="text-align: end">
              <h2>

              </h2>
            </CCol>
          </CRow>

        </CCardHeader>

      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import VueContext from "vue-context";

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      change_refer_modal: false,
      async_person_search: false,
      refer_person_options: [],
      table_clicks: 0,
      table_clicks_timer: null,

      start_date: '',
      end_date: '',
      choose_driver: true,
      change_status_modal: false,
      selected_status: 0,
      status_list: [{label: this.$t('select'), value: 0}, {label: this.$t('withDriver'), value: 26}],
      // 23	ارجاع	10
      // 24	کالاها آماده ارسال	10
      // 25	تحویل سفیر	10
      // 26	در دست سفیر	10
      // 27	در مسیر تحویل	10
      // 28	تحویل شد	10
      change_status_summary: '',
      id_checkbox_items: [],
      refer_person: null,
      request_product_items: items.map((item, row_id) => {
        return {...item, row_id}
      }),

      exit_product_inventory_items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      exit_product_inventory_fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%', filter: false},
        // {key: 'docDate', label: this.$t('tables.date'), _style: 'width:15%'},
        {key: 'factorCode', label: this.$t('invoice'), _style: 'width:8%'},
        {key: 'partyName', label: this.$t('customer'), _style: 'width:10%'},
        {key: 'visitorName', label: this.$t('visitor'), _style: 'width:10%'},
        {key: 'toziKonande', label: this.$t('suggestedDriver'), _style: 'width:10%'},
        {key: 'carTitle', label: this.$t('car'), _style: 'width:10%'},
        {key: 'routeName', label: this.$t('route'), _style: 'width:10%'},
        {key: 'address', label: this.$t('address'), _style: 'width:20%'},
        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
        // {key: 'select', label: this.$t('tables.select'), filter: false, _style: 'width:5%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],

      status_form: 0,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },

    }
  },
  mounted() {
    this.start_date = this.get_today();
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {

    'start_date': function () {
      this.get_lists();
    },
    'end_date': function () {
      this.get_lists();
    },

  },
  methods: {
    print() {
      // Pass the element id here
      this.print_with_header_title_height('print_delivery_operation', 'print_delivery_operation_header', 'print_report_footer', this.doc_id_no, 300, 350)

      // this.$htmlToPaper('print_delivery_operation');
    },
    open_refer_modal() {
var self = this
      if (this.id_checkbox_items.length) {

        // factorId
        var finds = this.exit_product_inventory_items.filter(x => this.id_checkbox_items.includes(x.factorId));
        if (
            finds[0].toziKonandeId != null
            &&
            finds.length == finds.filter(x => x.toziKonandeId == finds[0].toziKonandeId).length) {
          this.async_person_search = false
          this.refer_person_options = [{
            userId: finds[0].toziKonandeId,
            personCode: finds[0].toziKonande,
            userName: "",
            surName: "",
            mobileNo: ""
          }]
          this.refer_person = finds[0].toziKonandeId;
          setTimeout(function (){
            self.async_person_search = true

          },500)

        }else{
          this.refer_person_options = []
          this.refer_person =null;
          this.async_person_search = true
        }
        // toziKonandeId

        this.change_refer_modal = true
      } else {
        this.$root.modal_component.show_validate_errors([this.$t('selectOne')])

      }
    },
    setDateFilter(e) {
      console.log(e.target.value);
      // this.endDate = new Date(e.target.value).getTime()
    },
    table_row_clicked(item, index, col) {
      if (col != "select") {

        this.table_clicks++;
        if (this.table_clicks == 1) {
          this.table_clicks_timer = setTimeout(() => {
            // this.result.push(event.type);
            this.table_clicks = 0
          }, 500);
        } else if (this.table_clicks > 1) {
          clearTimeout(this.table_clicks_timer);
          this.table_clicks = 0

          this.goShowDocument(item);

        }
      }

    },
    goShowDocument(item) {
      window.open('/dashboard/documents/show/' + item.factorId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.factorId});
    },
    change_status_data(index) {
      // if (this.selected_status == 0) {
      //   return false;
      // }
      this.change_status_modal = false;
      var self = this;

      const formData = new FormData();

      formData.append('MasterFactorId', this.id_checkbox_items[index]);
      formData.append('PersonId', this.refer_person);

      axios.post('AddFactorRefer', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if (index < self.id_checkbox_items.length - 1) {
            self.change_status_data(index + 1);
          } else {
            self.get_lists();
            self.change_refer_modal = false

            self.id_checkbox_items = [];
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.color != '') {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      if (this.color == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
      }
      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {

        backgroundColor: color

      }
    },
    get_image_file(item) {
      // console.log("image url is " + item.imageName);
      return this.$root.base_url + item.imageName;
    },
    edit_item(item) {
      // this.$set(item, '_toggled', !item._toggled)
      this.name = item.catTitle;
      this.color = item.color;
      this.code = item.code;
      this.description = item.summary;
      this.previewImage = item.image;
      this.status_form = item.factorId;
      setTimeout(() =>
              this.$refs.add_container.scrollIntoView()
          , 500);
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, emptyList() {
      // this.$set(item, '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, get_lists() {
      var self = this;

      const formData = new FormData();

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);
      formData.append('DocType', 3);
      formData.append('DeliveryType', 21);


      axios.post('GetDocsByStatusForDelivery', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.exit_product_inventory_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goSubCategories(item, index) {

      this.$router.push({path: '/dashboard/base/categories/' + this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    goToProductList(item) {
      this.$router.push({path: "/dashboard/products/list-cat/" + item.recId})
      // this.$router.push({ path: '/dashboard/base/categories/'+this.items[index].recId});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddMainCat";
      } else {
        url = "EditMainCat";
        formData.append('id', this.status_form)

      }

      formData.append('file', this.file);
      formData.append('MainCatTitle', this.name);
      formData.append('Color', this.color);
      formData.append('Code', this.code);
      if (this.$route.params.cat_id != null) {
        formData.append('IsParent', this.$route.params.cat_id);

      } else {
        formData.append('IsParent', 0);

      }
      formData.append('summary', this.description);
      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();


      })

          // axios.post(  '/admin/category', {
          //     name: self.name,
          //     description: self.description,
          //     image: self.image,
          //     cat: 0,
          // }).then(function (response) {
          //     self.name = '';
          //     self.description = '';
          //     // localStorage.setItem("api_token", response.data.access_token);
          //     // self.$router.push({ path: 'notes' });
          // })
          .catch(function (error) {
            console.log(error);
          });

    }, delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.recId;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteCat";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {
            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
